/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ZipLookupResult
 */
export interface ZipLookupResult {
    /**
     * 
     * @type {string}
     * @memberof ZipLookupResult
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof ZipLookupResult
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof ZipLookupResult
     */
    county: string;
}

/**
 * Check if a given object implements the ZipLookupResult interface.
 */
export function instanceOfZipLookupResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "city" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "county" in value;

    return isInstance;
}

export function ZipLookupResultFromJSON(json: any): ZipLookupResult {
    return ZipLookupResultFromJSONTyped(json, false);
}

export function ZipLookupResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ZipLookupResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'city': json['city'],
        'state': json['state'],
        'county': json['county'],
    };
}

export function ZipLookupResultToJSON(value?: ZipLookupResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'city': value.city,
        'state': value.state,
        'county': value.county,
    };
}

